import React from "react";
import HeaderOpenData from "./HeaderOpenData";
import FooterOpenData from "./FooterOpenData";
import ListDataOrganisasiDataOpenData from "./organisasi/ListDataOrganisasiDataOpenData";

const PagesOrganisasiDataOpenData = ({formatDate})=>{
    
    return(
        <div>
            <HeaderOpenData />
            <ListDataOrganisasiDataOpenData formatDate={formatDate} />
            <FooterOpenData />
        </div>
    )
}

export default PagesOrganisasiDataOpenData;